import { render, staticRenderFns } from "./AnnotatedImageView.vue?vue&type=template&id=6a49c693"
import script from "./AnnotatedImageView.vue?vue&type=script&lang=js"
export * from "./AnnotatedImageView.vue?vue&type=script&lang=js"
import style0 from "./AnnotatedImageView.vue?vue&type=style&index=0&id=6a49c693&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports